import { Logger } from '../../../utils/logger';

export type OrgPlanningLegacyScenarioUsage =
  | 'compatibility_read'
  | 'attempted_write'
  | 'migration_fallback'
  | 'presentation_only';

export type OrgPlanningLegacyScenarioPath =
  | 'successor_for_alias'
  | 'succession_canvas_draft'
  | 'succession_canvas_apply'
  | 'succession_canvas_discard'
  | 'succession_payload_v1'
  | 'diagram_scenario_delta';

/**
 * Value-free removal telemetry. Never pass folder, person, position, scenario,
 * source, or protected-field identifiers to this boundary.
 */
export function recordOrgPlanningLegacyScenarioUsage(
  usage: OrgPlanningLegacyScenarioUsage,
  path: OrgPlanningLegacyScenarioPath,
): void {
  Logger.info('OrgPlanningLegacyScenarioTelemetry', 'Legacy scenario path used', {
    usage,
    path,
    owner: 'atlas-platform',
    contractVersion: 'atlas-legacy-scenario-usage.v1',
  });
}
